import { Component, OnDestroy, ViewChild, inject, signal, effect, ChangeDetectionStrategy } from '@angular/core';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TopLevelMenuComponent } from '../top-level-menu/top-level-menu.component';
import { AppMenuService } from '../services/menu.service';
import { IconComponent } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-hamburger-menu',
	templateUrl: './hamburger-menu.component.html',
	styleUrls: ['./hamburger-menu.component.scss'],
	imports: [TopLevelMenuComponent, IconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HamburgerMenuComponent implements OnDestroy {
	private readonly appMenuService = inject(AppMenuService);

	showTopLevelMenu = this.appMenuService.showTopLevelMenu;

	open = signal(false);

	private readonly subscriptions: Subscription[] = [];

	@ViewChild(TopLevelMenuComponent, { static: true })
	private readonly menu!: TopLevelMenuComponent;

	constructor() {
		const router = inject(Router);

		this.subscriptions.push(
			router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
				this.close();
			})
		);

		effect(() => {
			if (this.showTopLevelMenu()) {
				this.close();
			}
		});
	}

	close() {
		this.open.set(false);
		if (this.menu) this.menu.close();
	}

	ngOnDestroy() {
		for (const sub of this.subscriptions) sub.unsubscribe();
	}
}
